import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { css, styled } from 'styled-components';

import { tk, withStyleModifiers } from '@sunwebgroup/ui-components';
import { hasActiveItemSelector, useQuickSearchStore } from './store';

function QuickSearchBarDesktop({
  children,
  className,
  disabled = false,
}: PropsWithChildren<{
  className?: string;
  disabled?: boolean;
}>) {
  const hasActiveItem = useQuickSearchStore(hasActiveItemSelector);

  return (
    <Wrapper className={className} $hasActiveItem={hasActiveItem} $isDisabled={disabled}>
      <Content>
        <PillItems>{children}</PillItems>
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $hasActiveItem: boolean; $isDisabled: boolean }>`
  --quicksearch-bar-background-color: ${tk('color_semantic_bg')};
  padding: 0 ${tk('spacing_md')};
  width: 100%;
  ${({ $hasActiveItem }) => $hasActiveItem && hasActiveItemMod()}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
      --quicksearch-bar-background-color: ${tk('color_semantic_bg_disabled')};

      ${Content} {
        background-color: ${tk('color_semantic_bg_disabled')};
      }
    `}
`;

const Content = styled.div`
  align-items: center;
  background-color: var(--quicksearch-bar-background-color);
  border-radius: ${tk('radius_rounded')};
  box-shadow: ${tk('shadow_md_bottom')};
  display: flex;
  height: var(--quicksearch-bar-height);
  margin: 0 auto;
  max-width: 100%;
  overflow: hidden;
  width: max-content;
  @media ${tk('mq_desktop_md')} {
    max-width: ${tk('breakpoint_desktop_lg')};
  }
`;

const PillItems = styled.div`
  display: flex;
  height: 100%;
`;

const hasActiveItemMod = () => css`
  --quicksearch-bar-background-color: ${tk('color_semantic_bg_subdued_hover')};
`;

const isFullWidthMod = () => css`
  background-color: var(--quicksearch-bar-background-color);
  box-shadow: ${tk('shadow_md_bottom')};

  ${Content} {
    border-radius: 0;
    box-shadow: none;
  }
`;

export default withStyleModifiers(styled(QuickSearchBarDesktop)``, {
  isFullWidthMod,
});
